
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  
   Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    setInterval(function(){
      var data = event.detail;
      Flits.shopCountryName = 'Hong Kong';
    },1000);
  });
}(Flits));
